import { NgModule, Optional, SkipSelf, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { I18NService } from './i18n/i18n.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { DelonModule } from '../delon.module';
import { SharedModule } from './../shared/shared.module';
import { LayoutModule } from './../layout/layout.module';
import { RoutesModule } from '../routes/routes.module';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { DelonAuthModule, SimpleInterceptor } from '@delon/auth';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FormsModule } from '@angular/forms';
import { StartupService } from '@core/startup/startup.service';
import { ALAIN_I18N_TOKEN } from '@delon/theme';
import { DefaultInterceptor } from './net/default.interceptor';
import { default as ngLang } from '@angular/common/locales/zh';
import { NZ_I18N, zh_CN as zorroLang } from 'ng-zorro-antd';
// tslint:disable-next-line: no-duplicate-imports
import { DELON_LOCALE, zh_CN as delonLang } from '@delon/theme';
import { registerLocaleData } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { JsonSchemaModule } from '@shared/json-schema/json-schema.module';
import { DelonCacheModule } from '@delon/cache';
import { ThirdParamInterceptor } from './net/thirdparam.interceptor';

const LANG = {
    abbr: 'zh',
    ng: ngLang,
    zorro: zorroLang,
    delon: delonLang,
};

registerLocaleData(LANG.ng, LANG.abbr);
const LANG_PROVIDES = [
    { provide: LOCALE_ID, useValue: LANG.abbr },
    { provide: NZ_I18N, useValue: LANG.zorro },
    { provide: DELON_LOCALE, useValue: LANG.delon },
];

export function StartupServiceFactory(startupService: StartupService) {
    return () => startupService.load();
}
const APPINIT_PROVIDES = [
    StartupService,
    {
        provide: APP_INITIALIZER,
        useFactory: StartupServiceFactory,
        deps: [StartupService],
        multi: true,
    },
];

const I18NSERVICE_PROVIDES = [{ provide: ALAIN_I18N_TOKEN, useClass: I18NService, multi: false }];
const INTERCEPTOR_PROVIDES = [
    { provide: HTTP_INTERCEPTORS, useClass: SimpleInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ThirdParamInterceptor, multi: true },
];

export function I18nHttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, `assets/tmp/i18n/`, '.json');
}
const I18NSERVICE_MODULES = [
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: I18nHttpLoaderFactory,
            deps: [HttpClient],
        },
    }),
];

const FORM_MODULES = [JsonSchemaModule];



@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        DelonModule.forRoot(),
        SharedModule,
        LayoutModule,
        RoutesModule,
        DelonAuthModule,
        NzButtonModule,
        NzIconModule,
        FormsModule,
        DelonCacheModule,
        ...I18NSERVICE_MODULES,
        ...FORM_MODULES,
    ],
    exports: [SharedModule, LayoutModule],
    providers: [
        I18NService,
        ...LANG_PROVIDES,
        ...APPINIT_PROVIDES,
        ...I18NSERVICE_PROVIDES,
        ...INTERCEPTOR_PROVIDES
    ],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
